import { render, staticRenderFns } from "./EqualFieldsValidator.vue?vue&type=template&id=dd566872&"
import script from "./EqualFieldsValidator.vue?vue&type=script&lang=ts&"
export * from "./EqualFieldsValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports